import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/shared/header/Header";
import Footer from "../../components/shared/footer/Footer";
import Breadcrumb from "../../components/shared/breadcrumb/Breadcrumb";
import { STATIC_SERVER_URL, PRODUCT_SIZES, REDEMPTION_FEE, API_BASE_URL } from "../../config/config";
import AnalyticsService from "../../services/analytics";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { authorizedState, couponCodeDiscountState, loginModalState } from "atoms/atoms";
import useCart from "hooks/Cart";
import { calculateCouponDiscount, getTotalCouponReduction } from "utils/calculateCouponDiscount";

import "./cart.scss";

const Cart = () => {
  const {
    basket,
    removeFromBasket,
    updateQuantity,
    getTotalPrice,
    getRedemptionFee,
    clearBasket
  } = useCart();

  const setLoginModalState = useSetRecoilState(loginModalState);
  const authorized = useRecoilValue(authorizedState);
  const navigate = useNavigate();
  const [isCouponError, setIsCouponError] = React.useState(false);
  const [copuonErrorMessage, setCouponErrorMessage] = React.useState("");
  const [couponCodeDiscount, setCouponCodeDiscount] = useRecoilState(couponCodeDiscountState);

  React.useEffect(() => {
    AnalyticsService.sendPageView(window.location.pathname);
    console.log(couponCodeDiscount);
  }, []);

  const handleCheckoutButtonClick = () => {
    if (authorized) {
      navigate("/penztar");
    } else {
      setLoginModalState({
        isVisible: true,
        redirectAfterLogin: "/penztar"
      });
    }
  };

  const handleQuantityChange = (itemNo, size, newQuantity) => {
    updateQuantity(itemNo, size, parseInt(newQuantity) || 1);
  };

  const handleCouponSubmit = (e) => {
    e.preventDefault();
    const couponCode = e.target.elements[0].value.trim();

    if (!couponCode || couponCode.toString().length < 5) {
      setIsCouponError(true);
    } else {
      fetch(`${API_BASE_URL}/validate-coupon-code/${couponCode}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: basket.length > 0 ? JSON.stringify({ products: basket.map(item => item.id) }) : null,
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data.isValid) {
            setIsCouponError(false);
            setCouponErrorMessage("");
            setCouponCodeDiscount({
              name: couponCode,
              discountValue: data.discount_percent,
              applicableProducts: data.applicable_product_ids || [],
            });
          } else {
            setIsCouponError(true);
            setCouponErrorMessage(data.message);
            setCouponCodeDiscount({
              name: "",
              discountValue: 0,
            });
          }
        })
        .catch((e) => {
          console.log(e);
          setIsCouponError(true);
          setCouponErrorMessage("Hiba történt a kupon kód érvényesítése során.");
          setCouponCodeDiscount({
            name: "",
            discountValue: 0,
          });
        });
    }
  };

  return (
    <div>
      <Header />
      <Breadcrumb />
      <section className="main-content basket-details__container container">
        <div className="row">
          <div className="col-12">
            <h2 className="h2">Kosár</h2>
          </div>

          {basket.length > 0 ? (
            <>
              <div className="col-sm-12 col-lg-8">
                <table className="table basket-details__table show-desktop">
                  <thead>
                    <tr>
                      <th colSpan="2">Termék</th>
                      <th>Mennyiség</th>
                      <th style={{ textAlign: "right" }}>Egység ár</th>
                      <th>Összesen</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {basket.map((item) => (
                      <tr key={`${item.item_no}-${item.size}`}>
                        <td>
                          <img
                            src={`${STATIC_SERVER_URL}/web/images/shop/products/${item.item_no}_001.png`}
                            alt={item.name}
                            onError={(e) => {
                              e.target.src = `${STATIC_SERVER_URL}/web/images/shop/products/default.png`;
                            }}
                          />
                        </td>
                        <td className="product-detail">
                          <strong>{item.name}</strong>
                          {!!item.size && (
                            <p>
                              Méret: <input
                                className="form-control"
                                type="text"
                                readOnly
                                value={PRODUCT_SIZES[item.size]}
                              />
                            </p>
                          )}
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="number"
                            min="1"
                            value={item.quantity}
                            onChange={(e) => handleQuantityChange(item.item_no, item.size, e.target.value)}
                          />
                        </td>
                        <td>
                          {!item.discount_price && (
                            <span>{item.price.toLocaleString()} Ft</span>
                          )}
                          {!!item.discount_price && (
                            <>
                              <span>{item.discount_price.toLocaleString()} Ft</span>
                              <p className="original-price">Eredeti ár: {item.price.toLocaleString()} Ft</p>
                            </>
                          )}
                          {couponCodeDiscount.discountValue > 0 && couponCodeDiscount.applicableProducts.includes(item.id) && (
                            <p className="coupon-discount-value">
                              Kuponkedvezmény:
                              -{calculateCouponDiscount(item, 1, couponCodeDiscount).toLocaleString()} Ft
                            </p>
                          )}
                          {!!item.redemption_fee && (
                            <p><strong>+{REDEMPTION_FEE * item.quantity} Ft<sup>*</sup></strong></p>
                          )}
                        </td>
                        <td>
                          {!!item.discount_price && (
                            <>{(item.discount_price * item.quantity + (item.redemption_fee ? REDEMPTION_FEE * item.quantity : 0)).toLocaleString()} Ft</>
                          )}
                          {!item.discount_price && couponCodeDiscount.discountValue > 0 && couponCodeDiscount.applicableProducts.includes(item.id) && (
                            <>{(item.price * item.quantity - calculateCouponDiscount(item, item.quantity, couponCodeDiscount) + (item.redemption_fee ? REDEMPTION_FEE * item.quantity : 0)).toLocaleString()} Ft</>
                          )}
                          {!item.discount_price && (!couponCodeDiscount.discountValue || couponCodeDiscount.discountValue > 0 && !couponCodeDiscount.applicableProducts.includes(item.id)) && (
                            <>{(item.price * item.quantity + (item.redemption_fee ? REDEMPTION_FEE * item.quantity : 0)).toLocaleString()} Ft</>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn-remove-basket-item"
                            title="Törlés"
                            onClick={() => removeFromBasket(item.item_no, item.size)}
                          >
                            <svg
                              fill="none"
                              viewBox="0 0 14 16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m13.5 2.5h-2.5938l-1.06245-1.75c-.25-.40625-.8125-.75-1.28125-.75h-3.15625c-.46875 0-1.03125.34375-1.28125.75l-1.0625 1.75h-2.5625c-.28125 0-.5.25-.5.5v.5c0 .28125.21875.5.5.5h.5l.65625 10.5938c.03125.7812.71875 1.4062 1.5 1.4062h7.65625c.7813 0 1.4687-.625 1.5-1.4062l.6875-10.5938h.5c.25 0 .5-.21875.5-.5v-.5c0-.25-.25-.5-.5-.5zm-8.09375-1h3.15625l.59375 1h-4.34375zm5.40625 13h-7.65625l-.65625-10.5h8.9688z"
                                fill="#e36464"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p>* visszaváltási díj, összesen</p>
              </div>
              <div className="col-sm-12 col-lg-4">
                <div className="checkout-box">
                  <h3>Összegzés</h3>
                  <h4>Rendelés összértéke <span>{(getTotalPrice() + getRedemptionFee() - getTotalCouponReduction(basket, couponCodeDiscount)).toLocaleString()} Ft</span></h4>
                  {couponCodeDiscount.discountValue > 0 && (
                    <div className="coupon-discount-applied">
                      <p>&#10004; Kuponkód <i>{couponCodeDiscount.name}</i> érvényesítve!</p>
                    </div>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleCheckoutButtonClick}
                  >
                    megrendelés
                  </button>
                  <Link className="btn btn-secondary" to="/">
                    Tovább vásárolok
                  </Link>
                  <p>A megrendelés oldalon számlázási és szállítási adataidat adhatod meg.</p>
                </div>

                <div className={couponCodeDiscount.discountValue > 0 ? "checkout-box coupon-box disabled" : "checkout-box coupon-box"}>
                  <h3>Kupon</h3>
                  <p>Ha van kupon kódod, itt érvényesítheted. A kedvezmény mértékét automatikusan levonjuk a végösszegből.</p>
                  <form onSubmit={handleCouponSubmit}>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type="text"
                        disabled={couponCodeDiscount.discountValue > 0}
                      />
                      {isCouponError && <p className="error-message">{copuonErrorMessage}</p>}
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="btn btn-secondary"
                        disabled={couponCodeDiscount.discountValue > 0}
                      >
                        Érvényesít
                      </button>

                    </div>
                  </form>
                </div>
              </div>
            </>
          ) : (
            <div className="col-12">
              <p className="text-center">A kosaradban nincsenek termékek.</p>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Cart;
